import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  selectProjects,
  selectProjectsLimit,
  selectProjectsPage,
  setLimit,
  setMyProjects,
  setPage,
} from '../components/forms/projectsSlice';
import { getMyProjects } from '../api/projects';
import { Project } from '../types';

export const useMyProjects = () => {
  const [fetching, setFetching] = useState(false);

  const dispatch = useDispatch();

  const projects = useSelector(selectProjects);
  const statePage = useSelector(selectProjectsPage);
  const stateLimit = useSelector(selectProjectsLimit);

  const fetchProjects = useCallback(async (newPage?: number, newLimit?: number) => {
    try {
      setFetching(true);

      const page = newPage || statePage;
      const limit = newLimit || stateLimit;

      const data = await getMyProjects(page, limit);

      if (data) {
        dispatch(setMyProjects(data.projects as Project[]));

        if (newPage) {
          dispatch(setPage(newPage));
        }
        if (newLimit) {
          dispatch(setLimit(newLimit));
        }

      }
    } catch (error) {
    } finally {
      setFetching(false);
    }
  }, [statePage, stateLimit, dispatch]);

  return { projects, page: statePage, limit: stateLimit, fetching, fetchProjects };
};
